import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const InvalidRefreshTokenError = BaseErrorSchema.extend({
  errorType: z.literal('InvalidRefreshTokenError'),
});

export type InvalidRefreshTokenError = z.infer<typeof InvalidRefreshTokenError>;
